module.exports = __webpack_public_path__ + "img/pic-2-10.112ca583.png";